import React from "react";
import { CharacterProvider } from "./CharacterContext";
import { StoryboardStateProvider } from "./StoryboardStateContext";
import { StoryboardsProvider } from "./StoryboardsContext";
import { SignUpInfoProvider } from "./SignUpInfoContext";
import { CharacterCreatorStateProvider } from "./CharacterCreatorStateContext";
import { AuthProvider } from "./AuthContext";
import { UserProvider } from "./UserContext";
import { ImageIndexProvider } from "./ImageIndexContext";
import { IsDisabledProvider } from "./IsDisabledContext";
import { SelectedRFPProvider } from "./SelectedRFPContext";
import { MastheadRefProvider } from "./MastheadRefContext";
import { WebSocketProvider } from "./WebSocketContext";

const AppContextProvider = ({ children }) => {
  return (
    <MastheadRefProvider>
        
        <AuthProvider>
            <UserProvider>
                <WebSocketProvider>
                <SignUpInfoProvider>
                    <CharacterProvider>
                        <CharacterCreatorStateProvider>
                            <StoryboardsProvider>
                                <StoryboardStateProvider>
                                    <SelectedRFPProvider>
                                        <IsDisabledProvider>
                                            <ImageIndexProvider>
                                                {children}
                                            </ImageIndexProvider>
                                        </IsDisabledProvider>
                                    </SelectedRFPProvider>
                                </StoryboardStateProvider>
                            </StoryboardsProvider>
                        </CharacterCreatorStateProvider>
                    </CharacterProvider>
            </SignUpInfoProvider>
            </WebSocketProvider>
        </UserProvider>
    </AuthProvider>
</MastheadRefProvider>
  );
};

export default AppContextProvider;
